// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2kX2g","controls":"styles_controls__2UxM6","charLimit":"styles_charLimit__3-XAB","input":"styles_input__7JDef","send":"styles_send__2xv2K"};